import React from "react";
// nodejs library that concatenates classes
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
// core components
// import CustomInput from "components/CustomInput/CustomInput.jsx";
import Footer from "../Footer/Footer";

// import face1 from "assets/img/faces/card-profile6-square.jpg";
// import face2 from "assets/img/faces/christian.jpg";
// import face3 from "assets/img/faces/card-profile4-square.jpg";
// import face4 from "assets/img/faces/card-profile1-square.jpg";
// import face5 from "assets/img/faces/marc.jpg";
// import face6 from "assets/img/faces/kendall.jpg";
// import face7 from "assets/img/faces/card-profile5-square.jpg";
// import face8 from "assets/img/faces/card-profile2-square.jpg";

import sponsorOne from '../../../../assets/images/landing/sponsor1.jpg';
import sponsorTwo from '../../../../assets/images/landing/sponsor2.png';
import sponsorThree from '../../../../assets/images/landing/sponsor3.png';
import sponsorFour from '../../../../assets/images/landing/sponsor4.jpg';

import styles from "../styles/footerStyle.jsx";

const SectionFooter = props => {
  const { classes } = props;
  return (
    // <div className={classes.section}>
      <div>
        <Footer
          theme="white"
          content={
            <div>
              {/* <div className={classes.left}>
                <a
                  href="https://ioc.gov.ua"
                  className={classes.footerBrand}
                >
                  ДП "ІОЦ"
                </a>
              </div> */}
              <div className={classes.pullCenter}>
                <List className={classes.list}>
                  <ListItem className={classes.inlineBlock}>
                  <a href="https://www.msp.gov.ua/">
                      <img src={sponsorOne} alt="sponsor" width="120" />
                    </a>
                  </ListItem>
                  <ListItem className={classes.inlineBlock}>
                  <a href="https://www.ioc.gov.ua/">
                    <img src={sponsorTwo} alt="sponsor" width="120" />
                  </a>
                  </ListItem>
                  <ListItem className={classes.inlineBlock}>
                  <a href="https://donors.decentralization.gov.ua/project/u-lead">
                    <img src={sponsorThree} alt="sponsor" width="120" />
                  </a>
                  </ListItem>
                  <ListItem className={classes.inlineBlock}>
                  <a href="https://www.worldbank.org/uk/country/ukraine">
                    <img src={sponsorFour} alt="sponsor" width="120" />
                  </a>
                  </ListItem>
                </List>
              </div>
              {/* <div className={classes.rightLinks}>
                <ul>
                  <li>
                    <Button
                      href="https://twitter.com/CreativeTim"
                      color="twitter"
                      justIcon
                      simple
                    >
                      <i className="fab fa-twitter" />
                    </Button>
                  </li>
                  <li>
                    <Button
                      href="https://dribbble.com/creativetim"
                      color="dribbble"
                      justIcon
                      simple
                    >
                      <i className="fab fa-dribbble" />
                    </Button>
                  </li>
                  <li>
                    <Button
                      href="https://instagram.com/CreativeTimOfficial"
                      color="google"
                      justIcon
                      simple
                    >
                      <i className="fab fa-google-plus-g" />
                    </Button>
                  </li>
                </ul>
              </div> */}
            </div>
          }
        />
      
      </div>
    // </div>
  );
};

export default withStyles(styles)(SectionFooter);
